import { Button } from '@kanda-libs/ks-design-library';

import CantFindBankModal from './Modal';
import useCantFindBankButton from './useCantFindBankButton';

const CantFindBankButton: React.FunctionComponent = function () {
  const { onClick } = useCantFindBankButton();
  return (
    <>
      <Button.Text
        id="ob-cant-find-bank"
        label="Can't find your bank above?"
        icon="info"
        className="mt-6 w-full text-14-22 -mb-2 mb:mb-0"
        onClick={onClick}
        variant="ghost"
      />
      <CantFindBankModal />
    </>
  );
};

export default CantFindBankButton;
